// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"6fe648cb","404":"ef15669e"}[chunkId] + ".chunk.js";
};